module.exports = __webpack_public_path__ + "overview-a5b6df21/upsell_icon_green-0d5d5c13b6f65d5bf95ec15dbe592bcd.png";